import React, { FC, useEffect, useState } from "react";

interface DescrptionProps {
	text: string;
	className?: string;
	showLength: number;
}

const Description: FC<DescrptionProps> = ({ text, showLength, ...rest }) => {
	const [showmore, setShowmore] = useState(true);
	const [content, setContent] = useState("");

	useEffect(() => {
		setContent(text.slice(0, showLength));
	}, [text]);

	const handleShowMore = () =>
		setShowmore((current) => {
			if (current) {
				setContent(text);
				return false;
			}
			setContent(text.slice(0, showLength));
			return true;
		});

	if (text.length < showLength) {
		return <p {...rest}>{text}</p>;
	}

	return (
		<p {...rest}>
			{content}
			{showmore ? "..." : ""}{" "}
			<span className="description__see-more" onClick={handleShowMore}>
				{showmore ? "See more" : "See less"}
			</span>
		</p>
	);
};

export default Description;
